export enum RoleType {
  Permissions = 'Permissions',
  Access = 'Access',
}
